import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm text-gray-500">
              &copy; {new Date().getFullYear()} ImgAI. All rights reserved.
            </p>
          </div>
          <div className="flex space-x-6">
            <Link to="/terms-and-privacy" className="text-gray-500 hover:text-primary-600 transition-colors">
              Terms & Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 